import React, { Component } from 'react'
import { connect } from 'react-redux'
import { processDataForNewFunction } from '../../actions/Login'
import { notification, similar_text_array } from '../../services/helpers'
import $ from 'jquery'
import _ from 'underscore'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import SelectPlus from 'react-select-plus'
import { resumePDFChangeFunctionModalAriaLabel } from '../Constants/AriaLabelText'
import { injectIntl, FormattedMessage } from 'react-intl'

class ChangeFunction extends Component {
  constructor() {
    super()
    this.state = {
      studentProf: 'Student',
      jobFuncs: [],
      value: [],
      disabled: false,
      jobFunctionMapOptions: [],
      filters: [],
      suggestedFunction: [],
      resumeFunction: [],
      cfFunction: [],
      showSuggestedFunction: false,
      showResumeFunction: false,
      showCfFunction: false,
      interProdCount: 0,
    }
    this.studentProfFlag = false
    this.tags = {}
    this.targetFunctionBackToFrontEndMapping = {}
    this.displayNamesMapping = {}
    this.handleSubmit = this.handleSubmit.bind(this)
    this.debounceHandleSubmit = _.debounce(this.handleSubmit, 2000, true)
    this.getSelectedJobFunctionsAtTop =
      this.getSelectedJobFunctionsAtTop.bind(this)
    this.removeJobFunction = this.removeJobFunction.bind(this)
    this.onChangeTFSelect = this.onChangeTFSelect.bind(this)
    this.filterOptions = this.filterOptions.bind(this)
    this.filterOptionsEndState = this.filterOptionsEndState.bind(this)
    this.debounceTime = 3000
    this.trackClickDebounce = _.debounce(this.trackClick, 3000, true)
    this.trackProcessDebounce = _.debounce(this.trackProcess, 3000, true)
    this.resetFilter = this.resetFilter.bind(this)
    this.randomString = null
  }

  trackClick(tag) {
    sendTrackingData('event', 'aspire_change_function_modal', 'click', tag)
  }

  trackProcess(tag, error = true) {
    let process = error ? 'notify_error' : 'notify_success'
    sendTrackingData('process', 'aspire_change_function_modal', process, tag)
  }

  trackPageLoad(tag) {
    sendTrackingData('page_level', 'aspire_change_function_modal', 'load', tag)
  }

  UNSAFE_componentWillMount() {
    const { functions } = this.props
    this.tags = functions['tags']
    this.targetFunctionBackToFrontEndMapping = functions['mapping']
    this.displayNamesMapping = functions['display_names']

    let jobFunctionMapOptions = []

    _.mapObject(this.targetFunctionBackToFrontEndMapping, function (val, key) {
      let newItem = { label: (this.displayNamesMapping && this.displayNamesMapping[key]) || val, value: key }
      jobFunctionMapOptions.push(newItem)
    }, this)

    this.setState({ jobFunctionMapOptions: jobFunctionMapOptions })
    this.trackPageLoad('page_loading')
    this.randomString = this.generateRandomString(20)
  }

    componentDidUpdate(prevProps, prevState) {
    $('.sf-select-class .Select-value').css('display', 'none')
    const {
      jobFuncs,
      showResumeFunction,
      resumeFunction,
      showCfFunction,
      cfFunction,
      suggestedFunction,
      showSuggestedFunction,
      interProdCount,
    } = this.state
    let cfFunctionCount = 0
    let resumeFunctionCount = 0
    let suggestedFunctionCount = 0
    let stateObj = {}
    if (prevState.jobFuncs.length < jobFuncs.length && interProdCount > 0) {
      _.map(cfFunction, (value) => {
        if (!_.contains(jobFuncs, value.value)) {
          cfFunctionCount++
        }
      })
      _.map(resumeFunction, (value) => {
        if (!_.contains(jobFuncs, value.value)) {
          resumeFunctionCount++
        }
      })
      _.map(suggestedFunction, (value) => {
        if (!_.contains(jobFuncs, value.value)) {
          suggestedFunctionCount++
        }
      })
      if (cfFunction.length > 0 && resumeFunction.length > 0) {
        if (cfFunctionCount == 0) {
          stateObj.showResumeFunction = true
        } else if (resumeFunctionCount == 0) {
          stateObj.showCfFunction = true
        }
      } else if (
        cfFunction.length == 0 &&
        resumeFunction.length > 0 &&
        suggestedFunction.length > 0
      ) {
        if (suggestedFunctionCount == 0) {
          stateObj.showResumeFunction = true
        } else if (resumeFunctionCount == 0) {
          stateObj.showSuggestedFunction = true
        }
      } else if (
        cfFunction.length > 0 &&
        resumeFunction.length == 0 &&
        suggestedFunction.length > 0
      ) {
        if (suggestedFunctionCount == 0) {
          stateObj.showCfFunction = true
        } else if (cfFunctionCount == 0) {
          stateObj.showSuggestedFunction = true
        }
      }
      if(!_.isEmpty(stateObj)){
        this.setState(stateObj)
      }

      if (prevProps.function_mappings !== this.props.function_mappings) {
        const { functions } = this.props
        this.tags = functions['tags']
        this.targetFunctionBackToFrontEndMapping = functions['mapping']
        this.displayNamesMapping = functions['display_names']

        let jobFunctionMapOptions = []

        _.mapObject(this.targetFunctionBackToFrontEndMapping, function (val, key) {
          let newItem = { label: (this.displayNamesMapping && this.displayNamesMapping[key]) || val, value: key }
          jobFunctionMapOptions.push(newItem)
        }, this)

        this.setState({ jobFunctionMapOptions: jobFunctionMapOptions })
      }
    }
  }



  generateRandomString(length = 10) {
    let text = ''
    let possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }

    return text
  }

  filterOptionsEndState(options, filter, currentValues) {
    if (filter.length > 0) {
      if (filter.length <= 25) {
        this.state.filters.push(filter)
      }
    }

    if (filter.length < 3 || filter.length > 25) {
      return this.filterOptions(options, filter, currentValues)
    }

    const translatedJobFuncs = this.state.jobFuncs.map(
      func => this.displayNamesMapping[func] || func
    );
    return similar_text_array(
      options,
      filter,
      this.tags,
      this.displayNamesMapping,
      translatedJobFuncs
    )
  }

  filterOptions(options, filter, currentValues) {
    var filterOriginal = filter
    filter = filter.toLowerCase()
    var retOptions = []
    var tempOptions = []
    var pos = -1
    var present = 0
    for (var i = 0; i < options.length; i++) {
      var label = options[i]['label'].toLowerCase()
      var value = options[i]['value'].toLowerCase()
      if (present !== 1 && label === filter) {
        present = 1
      }
      pos = label.indexOf(filter)
      if (pos === 0) {
        retOptions.push(options[i])
      } else if (pos > 0) {
        tempOptions.push(options[i])
      } else if (options[i]['group']) {
        var groupLabel = options[i]['group']['label'].toLowerCase()
        var posGroup = groupLabel.indexOf(filter)
        if (posGroup >= 0) {
          tempOptions.push(options[i])
        }
      }
    }
    for (var i = 0; i < tempOptions.length; i++) {
      retOptions.push(tempOptions[i])
    }

    return retOptions
  }
  componentDidMount() {
    this.trackPageLoad('page_loaded')
    const { suggestedFunction, resumeFunctions, cfFunctions, feedback } =
      this.props

    if (!_.isNull(feedback)) {
      this.setState({
        jobFuncs: [...feedback['student_dashboard']['targetJobFunctions']],
      })
    }

    let interProdCount = 0
    let count = 0
    if (!_.isEmpty(cfFunctions)) {
      let cfSuggested = []
      const { jobFunctionMapOptions } = this.state
      _.map(jobFunctionMapOptions, (value) => {
        if (
          _.contains(cfFunctions, value.value.toLowerCase()) ||
          _.contains(cfFunctions, value.value)
        ) {
          cfSuggested.push(value)
        }
      })
      if (!_.isEmpty(cfSuggested)) {
        interProdCount++
      }
      this.setState({
        cfFunction: [...cfSuggested],
      })
      if (!count) {
        this.setState({
          showCfFunction: true,
        })
      }
      count = 1
    }
    if (!_.isEmpty(resumeFunctions)) {
      let resumeSuggested = []
      const { jobFunctionMapOptions } = this.state
      _.map(jobFunctionMapOptions, (value) => {
        if (
          _.contains(resumeFunctions, value.value.toLowerCase()) ||
          _.contains(resumeFunctions, value.value)
        ) {
          resumeSuggested.push(value)
        }
      })
      if (!_.isEmpty(resumeSuggested)) {
        interProdCount++
      }
      this.setState({
        resumeFunction: [...resumeSuggested],
      })
      if (!count) {
        this.setState({
          showResumeFunction: true,
        })
      }
      count = 1
    }
    if (!_.isEmpty(suggestedFunction)) {
      let suggested = []
      const { jobFunctionMapOptions } = this.state
      _.map(jobFunctionMapOptions, (value) => {
        if (
          _.contains(suggestedFunction, value.value.toLowerCase()) ||
          _.contains(suggestedFunction, value.value)
        ) {
          suggested.push(value)
        }
      })
      this.setState({
        suggestedFunction: [...suggested],
      })
      if (!count) {
        this.setState({
          showSuggestedFunction: true,
        })
      }
    }
    this.setState({ interProdCount })
    this.selectFunctionHeading.focus()
    //   'Select by using down arrow key or type to filter, minimum 1 function need to be selected, press tab to view feedback button'
    let filterAria = this.props.intl.formatMessage({
      id: "aspire.changeFunction.selectTargetFunctionsAria",
      defaultMessage: "Select target functions (max 3)"
    })
    //   .find('div.Select-placeholder')
    //   .attr('aria-label', filterAria)
    $('.sf-select-class')
      .find('div.Select-placeholder')
      .attr('aria-label', filterAria)
  }


  onChangeTFSelect(value, tag = '') {
    let val = value[0].value
    let bool = _.contains(this.state.jobFuncs, val)

    if (!bool) {
      if (_.size(this.state.jobFuncs) < 3) {
        var jobFuncs = [...this.state.jobFuncs]
        jobFuncs.push(val)
        let noOfFunctions = _.size(jobFuncs)
        if (noOfFunctions == 3) {
          this.setState({ disabled: true })
        }
        let jobFunctionMapOptions = this.state.jobFunctionMapOptions.filter(
          (obj) => obj.value !== val
        )
        this.setState({
          jobFunctionMapOptions: jobFunctionMapOptions,
          jobFuncs: [...jobFuncs],
        })
        this.trackClickDebounce(`Clicked on ${tag}${val}`)
      } else {
        notification(
          this.props.intl.formatMessage({
            id: "aspire.changeFunction.maxThreeFunctionsAllowed",
            defaultMessage: "Maximum 3 target functions allowed!"
          }),
          'error'
        )
        this.trackProcessDebounce('max_3_functions_allowed')
      }
    }

    this.setState({ filters: [] })
  }

  compare(a, b) {
    if (a.label < b.label) return -1
    if (a.label > b.label) return 1
    return 0
  }

  removeJobFunction(jobFunction) {
    let bool = _.contains(this.state.jobFuncs, jobFunction)

    if (bool == true) {
      if (_.size(this.state.jobFuncs) > 0) {
        let jsonObjectForTracking = {
          eventLabel: 'remove_job_function',
          jobFunctionRemoved: jobFunction,
          randomString: this.randomString,
        }
        this.trackClickDebounce(JSON.stringify(jsonObjectForTracking))

        var jobFuncs = this.state.jobFuncs.filter((jf) => jf !== jobFunction)
        let label = (this.displayNamesMapping && this.displayNamesMapping[jobFunction]) ||
          this.targetFunctionBackToFrontEndMapping[jobFunction]
        let newItem = { label: label, value: jobFunction }
        let jobFunctionMapOptions = $.extend(
          true,
          [],
          this.state.jobFunctionMapOptions
        )
        jobFunctionMapOptions.push(newItem)
        if (_.size(jobFuncs) < 3) {
          this.setState({ disabled: false })
        }
        this.setState({
          jobFunctionMapOptions: jobFunctionMapOptions,
          jobFuncs: [...jobFuncs],
        })
      }
    }
  }


  getSelectedJobFunctionsAtTop() {
    let output = []
    let jobFuncs = this.state.jobFuncs

    if (jobFuncs.length == 0) {
      return null
    }

    for (let i = 0; i < jobFuncs.length; i++) {
      let label = (this.displayNamesMapping && this.displayNamesMapping[jobFuncs[i]]) ||
        this.targetFunctionBackToFrontEndMapping[jobFuncs[i]]
      output.push(
        <li className="tf-li text-wrap" key={jobFuncs[i]}>
          <span
            className="sf-name"
            tabIndex={0}
            aria-label={this.props.intl.formatMessage(
              { id: "aspire.changeFunction.selectedFunctionAria", defaultMessage: "{functionName} is selected" },
              { functionName: label }
            )}
          >
            {label}
          </span>
          <a
            tabIndex={0}
            aria-label={this.props.intl.formatMessage(
              { id: "aspire.changeFunction.removeFunctionAria", defaultMessage: "click to remove {functionName} from target functions" },
              { functionName: label }
            )}
            href="javascript:void(0);"
            onClick={() => this.removeJobFunction(jobFuncs[i])}
            className="sf-cross icon-cross float-end"
          />
        </li>
      )
    }

    return output
  }

  resetFilter() {
    this.setState({ filters: [] })
  }

  handleSubmit() {
    const { id, processDataForNewFunction, hideModal, feedback, intl } = this.props
    let targetJobFunctions = [].concat(
      feedback['student_dashboard']['targetJobFunctions']
    )
    var target_job_functions = [].concat(this.state.jobFuncs)
    var student_prof = ''
    if (this.studentProfFlag) {
      student_prof = this.state.studentProf
    }

    if (_.size(target_job_functions) < 1) {
      notification(
        this.props.intl.formatMessage({
          id: "aspire.changeFunction.noTargetFunctionsSelected",
          defaultMessage: "No target functions selected!"
        }),
        'error'
      )
      this.trackClickDebounce('view_feedback_button_with_no_tf-' + id)
      return
    }

    let intersect = _.intersection(targetJobFunctions, target_job_functions)

    if (
      intersect.length == targetJobFunctions.length &&
      intersect.length == target_job_functions.length
    ) {
      notification(
        this.props.intl.formatMessage({
          id: "aspire.changeFunction.targetFunctionsNotChanged",
          defaultMessage: "Target Functions not changed!"
        }),
        'error'
      )
      this.trackClickDebounce('view_feedback_button_with_function_unchanged')
      return
    }

    let jsonObjectForTracking = {
      eventLabel: 'view_feedback_button',
      targetJobFunctions: target_job_functions,
      studentProfessional: student_prof,
      prevSessionFetchId: id,
      randomString: this.randomString,
    }
    sendTrackingData(
      'event',
      'dashboard_aspire_select_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )

    processDataForNewFunction(id, target_job_functions, intl)
    hideModal()
  }

  toggleSuggestedFunction() {
    const { showSuggestedFunction } = this.state
    this.setState({ showSuggestedFunction: !showSuggestedFunction })
  }

  toggleResumeFunction() {
    const { showResumeFunction } = this.state
    this.setState({ showResumeFunction: !showResumeFunction })
  }

  toggleCfFunction() {
    const { showCfFunction } = this.state
    this.setState({ showCfFunction: !showCfFunction })
  }

  renderSuggestedFunction() {
    const { suggestedFunction, jobFuncs, showSuggestedFunction } = this.state
    if (_.isEmpty(suggestedFunction)) {
      return null
    }

    let functionsCount = 0
    let functionList = (
      <ul
        className="suggested-tf-ul col col-sm-10"
        style={{ display: `${showSuggestedFunction ? `unset` : `none`}` }}
      >
        {_.map(suggestedFunction, (value) => {
          if (!_.contains(jobFuncs, value.value)) {
            functionsCount++
            return (
              <li
                onClick={() => this.onChangeTFSelect([value], 'suggested ')}
                className="suggested-tf-li"
                aria-label={this.props.intl.formatMessage(
                  { id: "aspire.changeFunction.addFunctionAria", defaultMessage: "Click to add {functionName} in target functions" },
                  { functionName: value.label }
                )}
                key={value.value}
              >
                <span className="icon-plus add-icon" />
                {value.label}
              </li>
            )
          }
        })}
      </ul>
    )

    if (functionsCount === 0) {
      return null
    }
    let dataLabel = this.props.intl.formatMessage({
      id: "aspire.changeFunction.trendingFunctionsLabel",
      defaultMessage: "Trending functions in your school"
    })
    return (
      <div className="sf-suggested-list row">
        <div className="top-functions col col-sm-2">
          <FormattedMessage
            id="aspire.changeFunction.trendingFunction"
            defaultMessage="{count, select, 1 {Trending function} other {Trending functions}}"
            values={{ count: functionsCount }}
          />
          <span
            data-tooltip={dataLabel}
            aria-label={dataLabel}
            className="tf-info tooltipped tooltipped-n"
          >
            i
          </span>
          <span
            className="drop-status float-end"
            onClick={() => this.toggleSuggestedFunction()}
          >
            <FormattedMessage
              id={showSuggestedFunction ? "aspire.changeFunction.hide" : "aspire.changeFunction.show"}
              defaultMessage={showSuggestedFunction ? "Hide" : "Show"}
            />
            <span
              className={`caret sf-caret ${
                showSuggestedFunction && `caret-reversed-blue`
              }`}
            ></span>
          </span>
        </div>
        {functionList}
      </div>
    )
  }

  renderResumeFunction() {
    const { allSmallResume } = this.props
    const { jobFuncs, showResumeFunction, resumeFunction } = this.state
    if (_.isEmpty(resumeFunction)) {
      return null
    }

    let functionsCount = 0
    let functionList = (
      <ul
        className="suggested-tf-ul col col-sm-10"
        style={{ display: `${showResumeFunction ? `unset` : `none`}` }}
      >
        {_.map(resumeFunction, (value) => {
          if (!_.contains(jobFuncs, value.value)) {
            functionsCount++
            return (
              <li
                onClick={() => this.onChangeTFSelect([value], 'resume ')}
                className="suggested-tf-li"
                aria-label={this.props.intl.formatMessage(
                  { id: "aspire.changeFunction.addFunctionAria", defaultMessage: "Click to add {functionName} in target functions" },
                  { functionName: value.label }
                )}
                key={value.value}
              >
                <span className="icon-plus add-icon" />
                {value.label}
              </li>
            )
          }
        })}
      </ul>
    )

    if (functionsCount === 0) {
      return null
    }
    let dataLabel = this.props.intl.formatMessage({
      id: "aspire.changeFunction.recommendedFunctionsLabel",
      defaultMessage: "Recommendations based on your {resumeType, select, cv {CV} other {resume}}"
    }, { resumeType: allSmallResume })
    return (
      <div className="sf-suggested-list row">
        <div className="top-functions col col-sm-2">
          <FormattedMessage
            id="aspire.changeFunction.recommendedFunction"
            defaultMessage="{count, select, 1 {Recommended function} other {Recommended functions}}"
            values={{ count: functionsCount }}
          />
          <span
            data-tooltip={dataLabel}
            aria-label={dataLabel}
            className="tf-info tooltipped tooltipped-n"
          >
            i
          </span>
          <span
            className="drop-status float-end"
            onClick={() => this.toggleResumeFunction()}
          >
            <FormattedMessage
              id={showResumeFunction ? "aspire.changeFunction.hide" : "aspire.changeFunction.show"}
              defaultMessage={showResumeFunction ? "Hide" : "Show"}
            />
            <span
              className={`caret sf-caret ${
                showResumeFunction && `caret-reversed-blue`
              }`}
            ></span>
          </span>
        </div>
        {functionList}
      </div>
    )
  }

  renderCFFunction() {
    const { jobFuncs, showCfFunction, cfFunction } = this.state
    if (_.isEmpty(cfFunction)) {
      return null
    }

    let functionsCount = 0
    let functionList = (
      <ul
        className="suggested-tf-ul col col-sm-10"
        style={{ display: `${showCfFunction ? `unset` : `none`}` }}
      >
        {_.map(cfFunction, (value) => {
          if (!_.contains(jobFuncs, value.value)) {
            functionsCount++
            return (
              <li
                onClick={() => this.onChangeTFSelect([value], 'CF ')}
                className="suggested-tf-li"
                aria-label={this.props.intl.formatMessage(
                  { id: "aspire.changeFunction.addFunctionAria", defaultMessage: "Click to add {functionName} in target functions" },
                  { functionName: value.label }
                )}
                key={value.value}
              >
                <span className="icon-plus add-icon" />
                {value.label}
              </li>
            )
          }
        })}
      </ul>
    )

    if (functionsCount === 0) {
      return null
    }
    let dataLabel = this.props.intl.formatMessage({
      id: "aspire.changeFunction.yourPreferredFunctionsLabel",
      defaultMessage: "Based on your preferences in Career Fit"
    })
    return (
      <div className="sf-suggested-list row">
        <div className="top-functions col col-sm-2">
          <FormattedMessage
            id="aspire.changeFunction.yourPreferredFunction"
            defaultMessage="{count, select, 1 {Your preferred function} other {Your preferred functions}}"
            values={{ count: functionsCount }}
          />
          <span
            data-tooltip={dataLabel}
            aria-label={dataLabel}
            className="tf-info tooltipped tooltipped-n"
          >
            i
          </span>
          <span
            className="drop-status float-end"
            onClick={() => this.toggleCfFunction()}
          >
            <FormattedMessage
              id={showCfFunction ? "aspire.changeFunction.hide" : "aspire.changeFunction.show"}
              defaultMessage={showCfFunction ? "Hide" : "Show"}
            />
            <span
              className={`caret sf-caret ${
                showCfFunction && `caret-reversed-blue`
              }`}
            ></span>
          </span>
        </div>
        {functionList}
      </div>
    )
  }

  render() {
    const {
      renderLoading,
      uploading_image,
      uploaded_image,
      aspirePrevFunction,
      feedback,
    } = this.props
    const { jobFuncs, interProdCount } = this.state
    let showStudentProfessional = null
    let showTFSelect = null
    let noResultsFound = (
      <div aria-live="assertive"
        aria-label={this.props.intl.formatMessage({
          id: "aspire.changeFunction.noResultFound",
          defaultMessage: "No Result found"
        })}
      >
        <FormattedMessage
          id="aspire.changeFunction.noResultFound"
          defaultMessage="No Result found"
        />
      </div>
    )
    this.state.jobFunctionMapOptions.sort(this.compare)

    let disableFeedback = false
    if (_.isEmpty(jobFuncs)) {
      disableFeedback = true
    }

    showTFSelect = (
      <div className="sf-dropdown-right-only">
        <SelectPlus
          className="sf-select-class"
          closeOnSelect={this.state.disabled}
          noResultsText={noResultsFound}
          searchable={true}
          multi
          valueKey="value"
          aria-label={this.props.intl.formatMessage({
            id: "aspire.changeFunction.selectTargetFunctionsAria",
            defaultMessage: "Select target functions (max 3)"
          })}
          tabSelectsValue={false}
          clearable={false}
          placeholder={this.props.intl.formatMessage({
            id: "aspire.changeFunction.selectTargetFunctionsPlaceholder",
            defaultMessage: "Select target functions (max 3)"
          })}
          options={this.state.jobFunctionMapOptions}
          filterOptions={this.filterOptionsEndState}
          onChange={this.onChangeTFSelect}
          onOpen={this.resetFilter}
          onClose={this.resetFilter}
        />
      </div>
    )

    if (uploading_image && !uploaded_image) {
      return renderLoading()
    }

    return (
      <div className="sf-container margin-t10">
        <div className="sf-header">
          <a
            href="javascript:void(0);"
            onClick={() => this.props.hideModal('close_btn')}
            aria-label={this.props.intl.formatMessage({
              id: "aspire.changeFunction.closeModalAria",
              defaultMessage: "Click to close the change function modal"
            })}
            className="icon-cross sf-modal-close-btn float-end"
          />
          <div className="tf-heading">
            <span
              ref={(heading) => {
                this.selectFunctionHeading = heading
              }}
              role="heading"
              aria-level="2"
            >
              <FormattedMessage
                id="aspire.changeFunction.heading"
                defaultMessage="Change your target job functions"
              />
            </span>
          </div>
        </div>
        <div className="sf-content">
          {jobFuncs.length > 0 && (
            <div className="tf-content-text sf-content-func">
              <FormattedMessage
                id="aspire.changeFunction.selectedTargetFunctions"
                defaultMessage="{count, select, 1 {Your selected target function} other {Your selected target functions}}"
                values={{ count: jobFuncs.length }}
              />
            </div>
          )}
          <div className="sf-selected-function-list">
            {this.getSelectedJobFunctionsAtTop()}
          </div>
          <div className="tf-content-text sf-content-des">
            <FormattedMessage
              id="aspire.changeFunction.chooseTargetFunctions"
              defaultMessage="Choose target functions from the list (up to 3)"
            />
          </div>
          {showTFSelect}
          {this.renderCFFunction()}
          {this.renderResumeFunction()}
          {interProdCount < 2 ? this.renderSuggestedFunction() : null}
        </div>
        <div className="sf-footer-screen function-tf-footer">
          <div className="sf-info-bottom">
            <FormattedMessage
              id="aspire.changeFunction.footerInfo"
              defaultMessage="* Changing target functions may change your profile strength score and corresponding feedback"
            />
          </div>
          <a
            href="javascript:void(0);"
            aria-label={this.props.intl.formatMessage(
              {
                id: "aspire.changeFunction.continueButtonAria",
                defaultMessage:
                  "{disableFeedback, select, true {Please select target functions it's mandatory, shft tab to select functions} false {click to view feedback, or just shift tab to remove or add target functions} other {Please select target functions it's mandatory, shft tab to select functions}}"
              },
              { disableFeedback: disableFeedback }
            )}
            type="button"
            data-value="default"
            onClick={this.debounceHandleSubmit}
            className=""
          >
            <button
              tabIndex={-1}
              disabled={disableFeedback}
              className="btn btn-primary sf-feedback-btn"
            >
              <FormattedMessage
                id="aspire.changeFunction.continueButton"
                defaultMessage="Continue"
              />
            </button>
          </a>
        </div>
        {this.props.aspireTracker('function_screen')}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    functions: state.aspireFunctionMappings.function_mappings,
    suggestedFunction: state.aspireFunctionMappings.suggested_function,
    show_student_professional:
      state.aspireLinkedinConnect.show_student_professional,
    aspirePrevFunction: state.aspireFunctionMappings.prev_function,
    resumeFunctions: state.aspireFunctionMappings.resume_functions,
    cfFunctions: state.aspireFunctionMappings.cf_functions,
    feedback: state.aspireFeedbackData.data,
    allSmallResume: state.aspireFeedbackData.allSmallResume
  }
}

export default connect(mapStateToProps, {
  processDataForNewFunction,
})(injectIntl(ChangeFunction))
